import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteWorkoutMovement(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteWorkoutMovement = (workoutMovementId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`workout-movements/${workoutMovementId}/`);
  };

  return useMutation(deleteWorkoutMovement, {
    onSuccess: (_, workoutMovementId) => {
      queryClient.invalidateQueries({
        predicate: query =>
          query.queryKey[0] === 'workoutMovements' && query.queryKey[1] !== workoutMovementId,
      });
    },
  });
}
